import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/opt/build/repo/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Tajawal\",\"arguments\":[{\"weight\":[\"400\",\"700\",\"900\"],\"subsets\":[\"arabic\"],\"preload\":true}],\"variableName\":\"tajawal\"}");
;
import(/* webpackMode: "eager", webpackExports: ["EnabledSourcesCookieSync"] */ "/opt/build/repo/src/components/enabled-sources-cookie-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/fullscreen-controller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/html-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/intl-provider-wrapper.tsx");
